import { useCallback } from 'react'
import { Dialogs } from 'features/dialog/dialogSlice'
import { useDispatch } from 'react-redux'

let lastIndex = 0

export const getLastDialogIndex = () => `dialog_${lastIndex++}`

export const useCreateDialogHook = (Component, id, changeLayoutClass) => {
  const dispatch = useDispatch()
  const WrappedComponent = useCallback(
    props => (
      <Component id={id} {...props} changeLayoutClass={changeLayoutClass} />
    ),
    [id, changeLayoutClass]
  )
  const showDialog = useCallback(
    () => dispatch(Dialogs.show(id)),
    [dispatch, id]
  )
  const hideDialog = useCallback(
    () => dispatch(Dialogs.hide(id)),
    [dispatch, id]
  )

  return [WrappedComponent, showDialog, hideDialog]
}
